<template>
  <div class="v-page">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="pageSizes"
      :page-size="mPageSize"
      :layout="layout"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "VPage",
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: [Number, null],
      default: null //待完善
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 50, 100, 200];
      }
    },
    pageSize: {
      type: Number,
      default: 0
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper"
    },
    background: {
      type: Boolean,
      default: false
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    mPageSize() {
      return this.pageSize || 20;
    }
  },
  methods: {
    handleSizeChange(val) {
      // this.currentPage = 1;
      // this.$emit("change", this.currentPage, val);
      this.$emit("update:page", 1);
      this.$emit("update:pageSize", val);
      this.$emit("change", 1, val);
    },
    handleCurrentChange(val) {
      // this.$emit("change", val, this.pageSize);
      this.$emit("update:page", val);
      this.$emit("change", val, this.mPageSize);
    }
  }
};
</script>

<style lang="scss" scoped>
.v-page {
  text-align: right;
  margin-top: 10px;
}
</style>
